export const MAP_TOKEN = "pk.eyJ1IjoibXRzdWt1IiwiYSI6ImNsajJzNTV6cTB4ajgzbGxkMDF6cXIwcGgifQ.8QfJP1tuUjqiPC7TZ4gMHQ"